import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SignInPage from './pages/SignInPage';
import SignUpPage from './pages/SignUpPage';
import Sidebar from './components/SideBar/Sidebar';
import Dashboard from './pages/Dashboard';
import Chatbot from './pages/Chatbot';
import MainSidebar from './components/SideBar/MainSideBar';
import Profile from './pages/Profile';
import ChangePassword from './pages/ChangePassword';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import PrivateRoute from './components/PrivateRoute';
import { useUser } from './context/UserContext';

const AdminRoute = ({ children }) => {
  const { user, loading } = useUser();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!user || user.role !== 'admin') {
    return <Navigate to="/chatbot" replace />;
  }
  
  return children;
};

const App = () => {
  const storedSelectedMenu = localStorage.getItem('selectedMenu');
  const initialSelectedMenu = storedSelectedMenu ? JSON.parse(storedSelectedMenu) : 0;

  const [selectedMenu, setSelectedMenu] = useState(initialSelectedMenu);

  useEffect(() => {
    localStorage.setItem('selectedMenu', JSON.stringify(selectedMenu));
  }, [selectedMenu]);

  return (
    <AuthProvider>
      <UserProvider>
        <Router>
          <Routes>
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/signup" element={<SignUpPage />} />

            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <AdminRoute>
                    <div style={{ display: 'flex' }}>
                      <MainSidebar />
                      <Sidebar selectedMenu={selectedMenu} setSelectedMenu={setSelectedMenu} />
                      <Dashboard />
                    </div>
                  </AdminRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/chatbot"
              element={
                <PrivateRoute>
                  <div style={{ display: 'flex' }}>
                    <MainSidebar />
                    <Sidebar selectedMenu={selectedMenu} setSelectedMenu={setSelectedMenu} />
                    <Chatbot />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <div style={{ display: 'flex' }}>
                    <MainSidebar />
                    <Sidebar selectedMenu={selectedMenu} setSelectedMenu={setSelectedMenu} />
                    <Profile />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/change_password"
              element={
                <PrivateRoute>
                  <div style={{ display: 'flex' }}>
                    <MainSidebar />
                    <Sidebar selectedMenu={selectedMenu} setSelectedMenu={setSelectedMenu} />
                    <ChangePassword />
                  </div>
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/signin" replace />} />
          </Routes>
        </Router>
      </UserProvider>
    </AuthProvider>
  );
};

export default App;
